/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GuardianDto } from '../../models/guardian-dto';

export interface UserGuardianControllerFindAllByChildId$Params {

/**
 * 아동 ID
 */
  childId: string;

/**
 * 센터 ID
 */
  centerId: string;

/**
 * 검색어
 */
  query?: string;
}

export function userGuardianControllerFindAllByChildId(http: HttpClient, rootUrl: string, params: UserGuardianControllerFindAllByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GuardianDto>>> {
  const rb = new RequestBuilder(rootUrl, userGuardianControllerFindAllByChildId.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GuardianDto>>;
    })
  );
}

userGuardianControllerFindAllByChildId.PATH = '/api/guardian/user/child';
